import Aos from "aos";
import React, { useEffect } from "react";

import { BsFacebook, BsFillTelephoneFill, BsGithub } from "react-icons/bs";
import { FaAddressBook, FaLinkedin, FaRegHandPointRight } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
const Contact = () => {
  useEffect(() => {
    Aos.init({
      duration: 2000,
    });
  }, []);

  return (
    <div className="">
      <h1 className="uppercase text-primary my-5 lg:text-2xl font-bold flex justify-center">
        Feel free to contact me{" "}
      </h1>
      <div
        data-aos="fade-up"
        className="grid lg:grid-cols-2 items-center  gap-5 h-[100vh]"
      >
        <div className=" mx-auto">
          <h1 className="font-bold text-primary text-2xl uppercase">
            {" "}
            <FaAddressBook className="inline-block " /> Address
          </h1>
          <hr className="mt-3 font-bold w-1/2" />
          <p className="mt-3 text-base-100 text-xl">
            Ahmednagar, Paikpara <br /> Mirpur-1, Dhaka-1216
          </p>
          <h1 className="font-bold text-primary text-2xl mt-5 uppercase">
            {" "}
            <BsFillTelephoneFill className="inline-block " /> Phone
          </h1>
          <hr className="mt-3 font-bold w-1/3" />
          <p className="mt-3 text-base-100 text-xl">+88-01304830848</p>

          <h1 className="font-bold text-primary text-2xl mt-5 uppercase">
            {" "}
            <MdEmail className="inline-block" /> Email
          </h1>
          <hr className="mt-3 font-bold w-1/3" />
          <p className="mt-3 text-base-100 text-xl">
            nomanhabibullah65@gmail.com
          </p>

          <div className="mt-8 text-primary">
            <a
              href="https://github.com/Habibullah6"
              target="blank"
              className="text-xl inline-block mr-5"
            >
              <BsGithub />
            </a>
            <a
              href="https://www.linkedin.com/in/habibullah-nomani/"
              target="blank"
              className="text-xl inline-block mr-5"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://www.facebook.com/emma.mary.372661/"
              target="blank"
              className="text-xl inline-block"
            >
              <BsFacebook />
            </a>
          </div>
        </div>

        <div className="p-10 mx-auto">
          <div className="text-xl text-primary font-bold uppercase flex items-center">
            {" "}
            <FaRegHandPointRight />
            <h1 className="ml-2">Get In Touch</h1>
          </div>{" "}
          <hr className="mt-3 font-bold w-1/2" />
          <form>
            <input
              type="text"
              placeholder="Your Name"
              className="input w-full mt-5   "
            />
            <input
              type="text"
              placeholder="Your Email"
              className="input w-full mt-5  "
            />

            <textarea
              className="textarea w-full mt-5  "
              placeholder="Your Message"
            ></textarea>
            <input
              type="submit"
              value="Send"
              className="btn btn-primary w-full mt-5"
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
